import { lessThan } from 'localmed-core';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color, padding, space } from 'styled-system';

export const LayoutWrapper = styled('div')(
  ({ widgetUseTracked }: any) => css`
    display: flex;
    height: 100%;
    flex-direction: column;
    min-height: ${widgetUseTracked?.embedded ? 'auto' : '100vh'};
  `,
  lessThan(
    'md',
    css`
      min-height: auto;
    `
  )
);

export const LayoutBody = styled('main')(
  ({ theme }: any) => css`
    display: flex;
    flex: 1;
    background-color: ${theme.colors.background};
  `
);

export const HeaderWrapper = styled('div')(
  ({ theme }: any) =>
    css`
      box-sizing: border-box;
      margin: 0 auto;
      width: 100%;
      background-color: ${theme.colors.darkBlue};
      z-index: 2;
    `
);

export const FooterWrapper = styled('div')(
  css`
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 20;
    width: 100%;
  `
);

export const LayoutContainer = styled('div')(
  ({ theme, size, fullWidth }: any) => css`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin: 0 auto;
    // padding: 0 ${theme.space.lg};
    max-width: ${fullWidth ? 'auto' : theme.breakpoints[size]};
    width: 100%;
  `,
  space,
  color,
  padding
);
